export const formaIcons = [
	{
		iconName: 'feed-24',
	},
	{
		iconName: 'search-24',
	},
	{
		iconName: 'tasks-add-24',
	},
	{
		iconName: 'calendar-24',
	},
	{
		iconName: 'chats-24',
	},
	{
		iconName: 'collapse-24',
	},
	{
		iconName: 'expand-24',
	},
	{
		iconName: 'mail-unread-24',
	},
	{
		iconName: 'question-24',
	},
	{
		iconName: 'sign-request-24',
	},
	{
		iconName: 'task-card-only-24',
	},
	{
		iconName: 'task-card-with-text-24',
	},
	{
		iconName: 'tasks-warning-24',
	},
	{
		iconName: 'task-text-only-24',
	},
	{
		iconName: 'contacts-24',
	},
	{
		iconName: 'contact-24',
	},
	{
		iconName: 'move-24',
	},
	{
		iconName: 'priority-high-24',
	},
	{
		iconName: 'priority-low-24',
	},
	{
		iconName: 'sort-24',
	},
	{
		iconName: 'arrow-v1-L-down-24',
	},
	{
		iconName: 'arrow-v1-L-left-24',
	},
	{
		iconName: 'arrow-v1-L-right-24',
	},
	{
		iconName: 'arrow-v1-L-up-24',
	},
	{
		iconName: 'arrow-v1-S-down-24',
	},
	{
		iconName: 'arrow-v1-S-left-24',
	},
	{
		iconName: 'arrow-v1-S-right-24',
	},
	{
		iconName: 'arrow-v1-S-up-24',
	},

	{
		iconName: 'arrow-v2-L-down-24',
	},
	// {
	// 	iconName: 'arrow-v2-L-left-24',
	// },
	{
		iconName: 'arrow-v2-L-right-24',
	},
	{
		iconName: 'arrow-v2-L-up-24',
	},
	{
		iconName: 'arrow-v2-S-down-24',
	},
	{
		iconName: 'arrow-v2-S-left-24',
	},
	{
		iconName: 'arrow-v2-S-right-24',
	},
	{
		iconName: 'arrow-v2-S-up-24',
	},
	{
		iconName: 'attachment-24',
	},
	{
		iconName: 'info-24',
	},
	{
		iconName: 'more-menu-24',
	},
	{
		iconName: 'plus-24',
	},
	{
		iconName: 'sent-solid-24',
	},
	{
		iconName: 'hamburger-menu-24',
	},
	{
		iconName: 'clock-24',
	},
	{
		iconName: 'cross_v1-24',
	},
	{
		iconName: 'Doc-Income-24',
	},
	{
		iconName: 'done-v2-24',
	},
	{
		iconName: 'edit-text-24',
	},
	{
		iconName: 'favourites-24',
	},
	{
		iconName: 'sign-24',
	},
	{
		iconName: 'tasks-transit-history-24',
	},
	{
		iconName: '1f-logo-outline',
	},
	{
		iconName: '24',
	},
	{
		iconName: 'all-done-24',
	},
	{
		iconName: 'Attachment-Collection-24',
	},
	{
		iconName: 'copy-24',
	},
	{
		iconName: 'doc-excel-add-24',
	},
	{
		iconName: 'docs-add-24',
	},
	{
		iconName: 'docs-collection-24',
	},
	{
		iconName: 'folder-24',
	},
	{
		iconName: 'gant-24',
	},
	{
		iconName: 'grid-24',
	},
	{
		iconName: 'History-24',
	},
	{
		iconName: 'Participants-24',
	},
	{
		iconName: 'Personal-assign-24',
	},
	{
		iconName: 'Personal-select-24',
	},
	{
		iconName: 'print-24',
	},
	{
		iconName: 'question-filled-24',
	},
	{
		iconName: 'Re-v1-24',
	},
	{
		iconName: 're-v2-24',
	},
	{
		iconName: 'reminders-24',
	},
	{
		iconName: 'sign-collection-24',
	},
	{
		iconName: 'sign-journal-24',
	},
	{
		iconName: 'subtasks-collection-24',
	},
	{
		iconName: 'Tasks-change-history-24',
	},
	{
		iconName: 'tasks-links-add-24',
	},
	{
		iconName: 'tasks-links-appoint-24',
	},
	{
		iconName: 'Tasks-roadmap-24',
	},
	{
		iconName: 'tasks-subtasks-24',
	},
	{
		iconName: 'tasks-subtasks-add-24',
	},
	{
		iconName: 'tasks-subtasks-appoint-24',
	},
	{
		iconName: 'tasks-subtasks-check-24',
	},
	{
		iconName: 'Tasks-timeline-24',
	},
	{
		iconName: 'users-collection-24',
	},
	{
		iconName: 'alarm-24',
	},
	{
		iconName: 'chats-new-24',
	},
	{
		iconName: 'done-v1-24',
	},
	{
		iconName: 'eye-24',
	},
	{
		iconName: 'forward-24',
	},
	{
		iconName: 'kanban-24',
	},
	{
		iconName: 'more-menu-horizontal-24',
	},
	{
		iconName: 'notifications-24',
	},
	{
		iconName: 'profile-24',
	},
	{
		iconName: 'quick-mail-24',
	},
	{
		iconName: 'reply-24',
	},
	{
		iconName: 'reply-all-24',
	},
	{
		iconName: 'settings-more-24',
	},
	{
		iconName: 'Settings-v2-24',
	},
	{
		iconName: 'share-v1-24',
	},
	{
		iconName: 'subtask-add-24',
	},
	{
		iconName: 'table-24',
	},
	{
		iconName: 'Time-Sources-24',
	},
	{
		iconName: 'trash-24',
	},
	{
		iconName: 'video-call-24',
	},
	{
		iconName: 'Wiki-v1-24',
	},
	{
		iconName: 'download-24',
	},
	{
		iconName: 'download-all-24',
	},
	{
		iconName: 'File-box-24',
	},
	{
		iconName: 'upload-24',
	},
	{
		iconName: 'download-16',
	},
	{
		iconName: 'favorites-solid-16',
	},
	{
		iconName: 'Favourites-16',
	},
	{
		iconName: 'chats-fav-24',
	},
	{
		iconName: 'as-done-24',
	},
	{
		iconName: 'lock-24',
	},
	{
		iconName: 'logout-24',
	},
	{
		iconName: 'mobile-devices-24',
	},
	{
		iconName: 'not-for-me-24',
	},
	{
		iconName: 'personal-deligate-24',
	},
	{
		iconName: 'priority-regular-24',
	},
	{
		iconName: 'tasks-24',
	},
	{
		iconName: 'tasks-filled-24',
	},
	{
		iconName: 'Categories-24',
	},
	{
		iconName: 'categories-filled-24',
	},
	{
		iconName: 'favourites-filled-24',
	},
	{
		iconName: 'mail-24',
	},
	{
		iconName: 'mail-filled-24',
	},
	{
		iconName: 'reports-24',
	},
	{
		iconName: 'reports-filled-24',
	},
	{
		iconName: 'settings-24',
	},
	{
		iconName: 'settings-filled-24',
	},
	{
		iconName: 'info-52',
	},

	{
		iconName: 'access-audit-24',
	},
	{
		iconName: 'admin-24',
	},
	{
		iconName: 'enter-invite-24',
	},
	{
		iconName: 'filter-v2-24',
	},
	{
		iconName: 'kanban-solid-24',
	},
	{
		iconName: 'move-v1-24',
	},
	{
		iconName: 'personal-delegate-24',
	},
	{
		iconName: 'personal-remove-24',
	},
	{
		iconName: 'personal-settings-24',
	},
	{
		iconName: 'reface-24',
	},
	{
		iconName: 'security-24',
	},
	{
		iconName: 'chats-remove-24',
	},
	{
		iconName: 'no-notifications-24',
	},
	{
		iconName: 'phone-call-24',
	},
	{
		iconName: 'folder-add-24',
	},
	{
		iconName: 'image-24',
	},
	{
		iconName: 'clear-deleted-24',
	},
	{
		iconName: 'show-all-24',
	},
	{
		iconName: 'show-deleted-24',
	},
	{
		iconName: 'api-24',
	},
	{
		iconName: 'Cloud-Providers-24',
	},
	{
		iconName: 'Denormalise-24',
	},
	{
		iconName: 'extra-24',
	},
	{
		iconName: 'group-control-24',
	},
	{
		iconName: 'Smart-Access-24',
	},
	{
		iconName: 'smarts-24',
	},
	{
		iconName: 'SQL-inqury-24',
	},
	{
		iconName: 'pin-16',
	},
	{
		iconName: 'calendar-add-24',
	},
];
